import { logError, trackEvent } from '@/modules/analytics';
import { apiClient } from '@/modules/api';
import { DynamicAssessmentScreen, DynamicAssessmentProvider } from '@/modules/dynamicAssessments';
import { useOnboardingSurveyHost } from '@/modules/rulesEngine';
import { getConfig } from '@/modules/runtimeConfig';

// The dynamicAssessments module takes its api client, analytics sink and rules-engine
// host by injection, so this route is where the onboarding app's implementations are
// bound. That injection exists for VidaReactNative, which mounts the module with its
// own client and never sees `OnboardingRoot`; inside this app the implementations are
// simply our own modules.
//
// `analytics` is not optional here: these events are the funnel for the
// `onb_use_dynamic_assessment` rollout. Hoisted to module scope because both members
// are module-level imports, so the object has one identity for the app's lifetime.
// (DynamicAssessmentProvider would stabilize an inline object too — no need to lean on
// that when the wrapper can just be a constant.)
const analytics = { trackEvent, logError };

export default function DynamicAssessment() {
  const host = useOnboardingSurveyHost();

  return (
    <DynamicAssessmentProvider
      apiClient={apiClient}
      host={host}
      analytics={analytics}
      // Read through the config getter rather than `process.env`, so a consumer's
      // `config.transifexToken` reaches it. The module scopes `useT()` to its own
      // Transifex instance, which is why it needs the token as a value rather than
      // inheriting the `TXProvider` this route already sits inside.
      transifexToken={getConfig('transifexToken')}
    >
      <DynamicAssessmentScreen />
    </DynamicAssessmentProvider>
  );
}
